import { render, staticRenderFns } from "./LanguageTable.vue?vue&type=template&id=4061ed4e"
import script from "./LanguageTable.vue?vue&type=script&lang=js"
export * from "./LanguageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports